import Vue from "vue";
export var JobScheduleTeamEventBus = new Vue();